import { Check } from 'lucide-react';
import clsx from 'clsx';

export default function CheckMark({ show }) {
    return (
        <div className={clsx("min-w-[22px] min-h-[22px] max-w-[22px] max-h-[22px] bg-[#4B823D] rounded-full flex items-center justify-center transition-all absolute right-4 duration-300", show ? 'scale-100' : 'scale-0')}>
            <Check className="w-[16px] text-white stroke-white" />
        </div>
    )
}